import { Tooltip } from '../../../../components';
import './ResultsItem.css';

export const ResultsItem = ({ 
  id,
  title, 
  tooltip, 
  errorCount, 
  toImproveCount,
  toImproveIconType = 'question',
  children 
}) => {
  // Determine which status to show
  const renderStatus = () => {
    const statuses = [];
    
    if (errorCount && errorCount > 0) {
      statuses.push({
        text: `${errorCount} Error${errorCount !== 1 ? 's' : ''}`,
        iconType: 'error',
        tooltipText: `This section has ${errorCount} error${errorCount !== 1 ? 's' : ''} that need immediate attention`
      });
    }
    
    if (toImproveCount && toImproveCount > 0) {
      statuses.push({
        text: `${toImproveCount} To Improve`,
        iconType: toImproveIconType,
        tooltipText: `This section has ${toImproveCount} item${toImproveCount !== 1 ? 's' : ''} that could be improved`
      });
    }
    
    return statuses;
  };

  const statuses = renderStatus();

  return (
    <div id={id} className="results-item">
      <div className="results-item__header">
        <div className="results-item__header-left">
          <h2 className="results-item__title">{title}</h2>
          {tooltip && <Tooltip text={tooltip} />}
        </div>
        
        {statuses.length > 0 && (
          <div className="results-item__header-right">
            {statuses.map((status, index) => (
              <div key={index} className="results-item__status">
                <span className="results-item__status-text">{status.text}</span>
                <Tooltip 
                  text={status.tooltipText} 
                  iconType={status.iconType}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="results-item__content">
        {children}
      </div>
    </div>
  );
};

